module.exports = __webpack_public_path__ + "img/vertical-align-top.7fd39284.svg";